import { render } from "./AddMemberToChat.vue?vue&type=template&id=bca0b07e&ts=true"
import script from "./AddMemberToChat.ts?vue&type=script&lang=ts&external"
export * from "./AddMemberToChat.ts?vue&type=script&lang=ts&external"

import "./AddMemberToChat.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__